<template>
  <v-menu
    v-model="visible"
    max-width="290px"
    min-width="290px">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="internalValue"
        :label="label"
        :error-messages="errorMessages"
        persistent-hint
        prepend-icon="mdi-calendar"
        readonly
        outlined
        dense
        :filled="filled"
        :disabled="disabled"
        :class="{ 'pointer-none' : disabled }"
        v-bind="attrs"
        v-on="on">
      </v-text-field>
    </template>
    <v-date-picker
      v-model="internalValue"
      locale="js"
      :day-format="(date) => new Date(date).getDate()"
      no-title>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DatePicker',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [Object, String],
      default: null,
    },
    errorMessages: {
      type: [Array],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value ? moment(this.value).format('YYYY-MM-DD') : null
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>

<style scoped>
.pointer-none {
  pointer-events: none;
}
</style>
